import { render, staticRenderFns } from "./BotGenerateImage.vue?vue&type=template&id=e253b5a8&scoped=true&"
import script from "./BotGenerateImage.vue?vue&type=script&lang=js&"
export * from "./BotGenerateImage.vue?vue&type=script&lang=js&"
import style0 from "./BotGenerateImage.vue?vue&type=style&index=0&id=e253b5a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e253b5a8",
  null
  
)

export default component.exports